import { render, staticRenderFns } from "./trombi.vue?vue&type=template&id=9fe56324&scoped=true"
import script from "./trombi.vue?vue&type=script&lang=ts"
export * from "./trombi.vue?vue&type=script&lang=ts"
import style0 from "./trombi.vue?vue&type=style&index=0&id=9fe56324&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe56324",
  null
  
)

export default component.exports